import script from "./DocumentViewerModal.vue?vue&type=script&setup=true&lang=js"
export * from "./DocumentViewerModal.vue?vue&type=script&setup=true&lang=js"

import "./DocumentViewerModal.vue?vue&type=style&index=0&id=4f0319e6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4f0319e6"]])

export default __exports__